<template>
  <div class="ai-system">
    <div class="system-title">
      <div>建设企业AI操作系统</div>
<!--      <div class="play-box">
        <div class="box-icon">
          <img src="../../assets/image/play_yellow.svg" alt="">
        </div>
      </div>-->
    </div>
    <div class="system-content">
      <div class="system-left">
        <div class="left-item item1" :class="{'animate__animated animate__backInLeft': animateFlag}">
          <div class="left-icon"><img class="icon-img" src="../../assets/image/system_item_img01.png" alt=""></div>
          <div class="item-text">
            <div class="text-title">专属模型训练</div>
            <div class="text-desc">采集生产数据，建设AI知识库， 结合企业的业务背景训练专属模型</div>
          </div>
        </div>
        <div class="left-item item2 current" :class="{'animate__animated animate__backInLeft': animateFlag}">
          <div class="left-icon"><img class="icon-img" src="../../assets/image/system_item_img02.png" alt=""></div>
          <div class="item-text">
            <div class="text-title">企业工具集</div>
            <div class="text-desc">根据业务需求建设企业工具集</div>
          </div>
        </div>
        <div class="left-item item3" :class="{'animate__animated animate__backInLeft': animateFlag}">
          <div class="left-icon"><img class="icon-img" src="../../assets/image/system_item_img03.png" alt=""></div>
          <div class="item-text">
            <div class="text-title">自定义角色</div>
            <div class="text-desc">无限设置个性化的角色，提供差异化的业务服务</div>
          </div>
        </div>
        <div class="left-item item4 current" :class="{'animate__animated animate__backInLeft': animateFlag}">
          <div class="left-icon"><img class="icon-img" src="../../assets/image/system_item_img04.png" alt=""></div>
          <div class="item-text">
            <div class="text-title">私有化部署</div>
            <div class="text-desc">提供整体AI操作系统私有化部署</div>
          </div>
        </div>
        <div class="left-item item5 last" :class="{'animate__animated animate__backInLeft': animateFlag}">
          <div class="left-icon"><img class="icon-img" src="../../assets/image/system_item_img05.png" alt=""></div>
          <div class="item-text">
            <div class="text-title">深度学习</div>
            <div class="text-desc">打通企业各部门的生产系统，直连生产资料，深度学习并服务于 业务前台</div>
          </div>
        </div>
      </div>
      <div class="system-right">
        <div class="right-item item1" :class="{'animate': animateFlag}">
          <img src="../../assets/image/right_item01.png" alt="">
        </div>
        <div class="right-item item2" :class="{'animate': animateFlag}">
          <img src="../../assets/image/right_item02.png" alt="">
        </div>
        <div class="right-item item3" :class="{'animate': animateFlag}">
          <img src="../../assets/image/right_item03.png" alt="">
        </div>
        <div class="right-item item4" :class="{'animate': animateFlag}">
          <img src="../../assets/image/right_item04.png" alt="">
        </div>

        <img class="center-text" src="../../assets/image/ai_word.svg" alt="">
        <div class="bottom-text">大语言模型</div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        hoverShowText: false,
        hoverColor: 'red',
        animateFlag: false
      }
    },
    watch: {
      animateFlag(val) {
        console.log(val)
        this.animateFlag = val
        setTimeout(() => {
          this.animateFlag = false
        }, 2000)
      }
    },
    methods: {
      handleShow() {
        this.hoverShowText = true
      },
      handleHidden() {
        this.hoverShowText = false
      }
    }
  }
</script>

<style lang="less" scoped>
  .ai-system {
    color: #222222;
    .system-title {
      font-size: 56px;
      font-weight: 600;
      position: relative;
      margin-bottom: 68px;
      letter-spacing: 4px;
      .play-box {
        width: 72px;
        height: 72px;
        background-color: #fff;
        box-shadow: 0px 4px 38px 0px rgba(199,203,211,0.39);
        border-radius: 17px;
        position: absolute;
        right: 26px;
        top: 0;
        cursor: pointer;
        transition: all 1.5s;
        font-size: 12px;
        display: flex;
        align-items: center;
        justify-content: center;
        .box-text {
          text-align: left;
          margin-right: 14px;
          font-size: 14px;
          color: #222;
          .text-desc {
            font-size: 12px;
            color: #666666;
            margin-top: 8px;
          }
        }
        .box-icon {
          width: 44px;
          height: 44px;
        }
        &:hover {
          .box-icon {
            transform: scale(1.2);
          }
        }
      }
    }
    .system-content {
      display: flex;
      align-items: flex-start;
      max-width: 1200px;
      margin: 0 auto;
      .system-left {
        width: 410px;
        margin-right: 106px;
        .left-item {
          width: 100%;
          height: 142px;
          background-image: url(../../assets/image/system_bg_white.png);
          background-size: 100% 100%;
          background-repeat: no-repeat;
          display: flex;
          align-items: center;
          font-size: 16px;
          color: #666666;
          line-height: 1;
          padding: 22px 32px;
          box-sizing: border-box;
          .left-icon {
            .icon-img {
              width: 48px;
              height: 48px;
              margin-right: 20px;
            }
          }
          .item-text {
            text-align: left;
            .text-title {
              font-size: 24px;
              color: #2C6CE6;
              font-weight: 600;
              margin-bottom: 12px;
            }
            .text-desc {
              line-height: 1.5;
            }
          }
          &.current {
            background-image: url(../../assets/image/system_bg_blue.png);
            background-size: 100% 100%;
            background-repeat: no-repeat;
            .item-text {
              text-align: left;
              .text-title {
                font-size: 24px;
                color: #FFFFFF;
                font-weight: 600;
                margin-bottom: 12px;
              }
              .text-desc {
                line-height: 1.5;
                color: rgba(255,255,255,.8);
              }
            }
          }
          &.last {
            height: 145px;
          }
        }
      }
      .system-right {
        width: 686px;
        height: 829px;
        background-image: url(../../assets/image/system_right_bg.png);
        background-size: 100% 100%;
        background-repeat: no-repeat;
        position: relative;
        z-index: 9;
        .center-text {
          width: 142px;
          height: 117px;
          position: absolute;
          top: 37%;
          left: 53%;
          transform: translate(-50%, -50%);
        }
        .bottom-text {
          position: absolute;
          bottom: 48px;
          left: 52.5%;
          transform: translateX(-50%);
          font-size: 28px;
          color: #2C6CE6;
          font-weight: 600;
        }
        .right-item {
          img {
            width: 100%;
            height: 100%;
          }
        }
        .right-item.item1 {
          position: absolute;
          top: 90px;
          left: 74px;
          width: 172px;
          height: 172px;
          &.animate {
            animation:slide-in-tl .8s cubic-bezier(.25,.46,.45,.84) both 1.5s;
          }
          //background-color: #00b98d;
        }
        .right-item.item2 {
          position: absolute;
          top: 124px;
          right: 42px;
          width: 132px;
          height: 196px;
          &.animate {
            animation:slide-in-tr .8s cubic-bezier(.25,.46,.45,.84) both 1.5s;
          }
          //background-color: #af5b5e;
        }
        .right-item.item3 {
          position: absolute;
          left: -10px;
          bottom: 280px;
          width: 172px;
          height: 174px;
          &.animate {
            animation:slide-in-bl .8s cubic-bezier(.25,.46,.45,.84) both 1.5s;
          }
          //background-color: #0d84e0;
        }
        .right-item.item4 {
          position: absolute;
          right: 120px;
          bottom: 125px;
          width: 152px;
          height: 247px;
          &.animate {
            animation:slide-in-br .8s cubic-bezier(.25,.46,.45,.84) both 1.5s;
          }
          //background-color: #a13e0d;
        }
      }
    }
  }

  .my-button-hover:hover { display: var(--hover-color); }

  .navbar__link {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 3.5rem;
    width: 5.5rem;
    color: #6a778e;
    transition: 250ms ease all;
  }
  .navbar__link .box-text {
    //position: absolute;
    right: 0;
    //transform: translate(-3rem);
    display: none;
    color: #406ff3;
    padding: 0.75rem;
    transition: 250ms ease all;
  }
  .navbar__link:hover {
    color: #fff;
  }
  .navbar__link:hover .box-text {
    display: block;
    //transform: translate(-60px);
  }
  .navbar__menu {
    position: relative;
  }
  .navbar__item:last-child:before {
    content: "";
    position: absolute;
    opacity: 0;
    z-index: -1;
    top: 0;
    right: 1rem;
    width: 3.5rem;
    height: 3.5rem;
    background: #406ff3;
    border-radius: 17.5px;
    transition: 250ms cubic-bezier(1, 0.2, 0.1, 1.2) all;
  }

  @keyframes slide-in-tl {
    0% {
      transform: translateY(-500px) translateX(-500px);
      opacity: 0
    }
    100% {
      transform: translateY(0) translateX(0);
      opacity: 1
    }
  }

  @keyframes slide-in-tr {
    0% {
      transform: translateY(-500px) translateX(500px);
      opacity: 0
    }
    100% {
      transform: translateY(0) translateX(0);
      opacity: 1
    }
  }

  @keyframes slide-in-bl {
    0% {
      transform: translateY(500px) translateX(-500px);
      opacity: 0
    }
    100% {
      transform: translateY(0) translateX(0);
      opacity: 1
    }
  }

  @keyframes slide-in-br {
    0% {
      transform: translateY(500px) translateX(500px);
      opacity: 0
    }
    100% {
      transform: translateY(0) translateX(0);
      opacity: 1
    }
  }
</style>
<style lang="less">
  .left-item.item1 {
    --animate-duration: 0.3s;
  }
  .left-item.item2 {
    --animate-duration: 0.6s;
  }
  .left-item.item3 {
    --animate-duration: 0.9s;
  }
  .left-item.item4 {
    --animate-duration: 1.2s;
  }
  .left-item.item5 {
    --animate-duration: 1.5s;
  }
</style>